import { useFilters } from '@/platform/hooks/useFilters';
import {
    Container,
    Segment,
    SegmentContent,
    SegmentHeader,
    TabNav,
    TabNavItem,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import QuestionnaireForm from '../Questionnaires/components/QuestionnaireForm';
import Navigation from './components/Navigation';

export const navItems = [
    {
        value: 7,
        label: 'LKV 2026',
    },
    {
        value: 2,
        label: 'LKV 18-56 (niet meer actueel)',
    },
    {
        value: 3,
        label: 'LKV 56+ (niet meer actueel)',
    },
];

const QuestionnaireSettingsView = () => {
    const { auth } = usePage().props;
    const { filters, updateFilters } = useFilters(['questionnaire']);

    return (
        <Container fluid>
            <Navigation />

            <Segment>
                <SegmentHeader
                    header='LKV vragenlijst instellingen'
                    subheader='Gebruik deze sectie om klant specifieke lkv vragen te definiëren die in vragenlijsten zullen verschijnen.'
                />
                <SegmentContent>
                    <TabNav label='Categorie'>
                        {navItems.map(navItem => (
                            <TabNavItem
                                key={navItem.value}
                                active={filters.type == navItem.value}
                                onClick={() =>
                                    updateFilters('type', navItem.value)
                                }
                            >
                                {navItem.label}
                            </TabNavItem>
                        ))}
                    </TabNav>
                </SegmentContent>
            </Segment>

            <QuestionnaireForm
                submitUrl={`/customers/${auth?.user?.selected_customer_id}/services/lkv/settings/questionnaires`}
            />
        </Container>
    );
};

export default QuestionnaireSettingsView;
